import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  Grid,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./informationModal.module.scss";

interface IGDPRProps {
  onClose(): any;
  open: boolean;
}

export const GDPRModal: React.FC<DialogProps & IGDPRProps> = (props) => {
  const { t } = useTranslation();
  return (
    <Dialog open={props.open} fullScreen>
      <Grid justifyContent="flex-end" container>
        <div className={styles.cross} onClick={() => props.onClose()}>
          <CloseIcon fontSize="medium" color="primary" />
          <DialogContentText color="primary">{t("Close")}</DialogContentText>
        </div>
      </Grid>
      <Grid container direction="column" wrap="nowrap">
        <DialogContent>
          <DialogContentText color="primary">
            {t("INTEGRITETSPOLICY CURVES – ETT SYSTEM INOM ECOGUARD AB")}
          </DialogContentText>
          <p className={styles.gdprItalicText}>
            {t(
              "Integritetspolicyn uppdaterades den 5 oktober 2021 1 ECOGUARD VÄRNAR"
            )}
          </p>
          <br />
          <DialogContentText color="primary">
            {t("1. ECOGUARD VÄRNAR OM DIN PERSONLIGA INTEGRITET")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>
            {t("GDPR1")} <br />
            <br /> {t("GDPR2")} <br />
            <br /> {t("GDPR3")} <br />
            <br />
            {t("GDPR4")}
          </p>
          <br />
          <DialogContentText color="primary">
            {t("2. PERSONUPPGIFTSANSVARIG")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR5")}</p>
          <br />
          <DialogContentText color="primary">
            {t("3. PERSONUPPGIFTSBEHANDLING HOS ECOGUARD")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR6")}</p>
          <br />
          <DialogContentText color="primary">
            {t("4. VILKA PERSONUPPGIFTER BEHANDLAR ECOGUARD?")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>
            {t("GDPR7")} <br />
            <br /> {t("GDPR8")}
          </p>
          <br />
          <p className={styles.gdprFilledText}>{t("GDPR9")}</p>
          <hr />
          <p className={styles.gdprNormalText}>{t("GDPR10")}</p>
          <br />
          <p className={styles.gdprNormalText}>{t("GDPR11")}</p>
          <br />
          <p className={styles.gdprNormalText}>{t("GDPR12")}</p>
          <br />
          <p className={styles.gdprNormalText}>{t("GDPR13")}</p>
          <br />
          <p className={styles.gdprFilledText}>{t("GDPR14")}</p>
          <hr />
          <p className={styles.gdprNormalText}>{t("GDPR15")}</p>
          <br />
          <p className={styles.gdprNormalText}>{t("GDPR16")}</p>
          <br />
          <p className={styles.gdprNormalText}>{t("GDPR17")}</p>
          <br />
          <p className={styles.gdprNormalText}>{t("GDPR18")}</p>
          <br />
          <DialogContentText color="primary">
            {t("5. VÅR BEHANDLING AV PERSONUPPGIFTER")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR19")}</p>
          <br />
          <table>
            <tbody>
              <tr>
                <th>{t("GDPR20")}</th>
                <th>{t("GDPR21")}</th>
              </tr>
              <tr>
                <td>{t("GDPR22")}</td>
                <td>{t("GDPR23")}</td>
              </tr>
              <tr>
                <td>{t("GDPR24")}</td>
                <td>{t("GDPR25")}</td>
              </tr>
              <tr>
                <td>{t("GDPR26")}</td>
                <td>{t("GDPR27")}</td>
              </tr>
              <tr>
                <td>{t("GDPR28")}</td>
                <td>{t("GDPR29")}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <DialogContentText color="primary">
            {t("6. HUR LÄNGE BEVARAR VI DINA PERSONUPPGIFTER?")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>
            {t("GDPR30")}
            <br />
            <br />
            {t("GDPR31")}
            <br />
            <br /> {t("GDPR32")} <br />
            <br />
            {t("GDPR33")}
          </p>
          <br />
          <DialogContentText color="primary">
            {t("7. TILL VILKA LÄMNAR ECOGUARD UT DINA PERSONUPPGIFTER?")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>
            {t("GDPR34")}
            <br />
            <br />
            {t("GDPR35")}
            <br />
            <br />
          </p>
          <br />
          <table>
            <tbody>
              <tr>
                <th>{t("GDPR36")}</th>
                <th>{t("GDPR37")}</th>
              </tr>
              <tr>
                <td>{t("GDPR38")}</td>
                <td>{t("GDPR39")}</td>
              </tr>
              <tr>
                <td>{t("GDPR40")}</td>
                <td>{t("GDPR41")}</td>
              </tr>
              <tr>
                <td>{t("GDPR42")}</td>
                <td>{t("GDPR43")}</td>
              </tr>
              <tr>
                <td>{t("GDPR44")}</td>
                <td>{t("GDPR45")}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <DialogContentText color="primary">
            {t("8. ÖVERFÖRING AV PERSONUPPGIFTER TILL TREDJE LAND")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR46")}</p>
          <br />
          <DialogContentText color="primary">
            {t("9. DINA RÄTTIGHETER")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>
            {t("GDPR47")}
            <br />
            <br />
            {t("GDPR48")}
            <br />
            <br />
            {t("GDPR49")}
            <br />
            <br />
            {t("GDPR50")}
            <br />
            <br />
            {t("GDPR51")}
            <br />
            <br />
            {t("GDPR52")}
            <br />
            <br />
            {t("GDPR53")}
          </p>
          <br />
          <DialogContentText color="primary">
            {t("10. SKYDD AV DINA PERSONUPPGIFTER")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR54")}</p>
          <br />
          <DialogContentText color="primary">
            {t("11. ÄNDRINGAR")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR55")}</p>
          <br />
          <DialogContentText color="primary">
            {t("12. LÄS MER OM ECOGUARDS BEHANDLING AV PERSONUPPGIFTER")}
          </DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR56")}</p>
          <br />
          <DialogContentText color="primary">13. KONTAKT</DialogContentText>
          <p className={styles.gdprNormalText}>{t("GDPR57")}</p>
          <br />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            onClick={() => props.onClose()}
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Grid>
    </Dialog>
  );
};
